import { prisma } from "client";
import { loginEventBucket } from "./login-events.pure";

export const getLoginEventsByEmailAndWhiteLabel = async (
  email: string,
  whiteLabelId: string,
  lang: string = "en",
  now: Date = new Date()
) => {
  const user = await prisma.user.findUnique({
    where: {
      email_accessibleWhiteLabelId: {
        email,
        accessibleWhiteLabelId: whiteLabelId,
      },
    },
    select: { id: true },
  });
  if (!user) {
    return { active: [], past: [] };
  }

  const events = await prisma.event.findMany({
    where: {
      whiteLabelId,
      OR: [{ deletedAt: null }, { deletedAt: { isSet: false } }],
      profiles: { some: { userId: user.id } },
    },
    select: {
      id: true,
      slug: true,
      image: true,
      imageBlurhash: true,
      startDate: true,
      endDate: true,
      published: true,
      timezone: true,
      eventExperience: true,
      privacy: true,
      translations: {
        where: { language: { code: lang } },
        select: { name: true },
      },
      venues: {
        include: {
          translations: {
            where: { language: { code: lang } },
            select: { name: true },
          },
        },
      },
      profiles: {
        where: { userId: user.id },
        select: { active: true },
        orderBy: { createdAt: "desc" },
        take: 1,
      },
    },
  });

  const active: typeof events = [];
  const past: typeof events = [];
  for (const event of events) {
    const bucket = loginEventBucket(
      { published: event.published, endDate: event.endDate },
      event.profiles[0]?.active ?? false,
      now
    );
    (bucket === "active" ? active : past).push(event);
  }
  return { active, past };
};
